import { getPlansFromCms } from '@/utils/misc'
import axios from 'axios'

export default {
  async extractStripeData({ commit }, { currencySelected, tagType }) {
    const tempStripePlansHolder = []
    const {
      data: { data: stripeCMSData },
    } = await axios.get(`${getPlansFromCms(tagType)}`)
    const isTestModeOn = process.env.VUE_APP_SERVERTYPE === 'staging'

    stripeCMSData.forEach((element) => {
      let temporaryPlanObject = null

      const { parameters, name, stripeTest, stripeProduction, icon } = element.attributes
      // eslint-disable-next-line no-unused-vars
      const { id, ...planMetaData } = parameters
      temporaryPlanObject = {
        planName: name,
        icon: {
          iconName: icon.data.attributes.name,
          url: icon.data.attributes.url.replace(/\/uploads/g, 'https://cms.cloudify.biz/uploads'),
        },
        planMetaData,
        billingCycle: {
          monthly: {
            priceId: null,
            amount: null,
            multiPriceIds: null,
          },
          yearly: {
            priceId: null,
            amount: null,
            multiPriceIds: null,
          },
        },
      }

      let productsData = null
      if (isTestModeOn) {
        productsData = stripeTest
        planMetaData.productId = productsData.productId
      } else {
        productsData = stripeProduction
        planMetaData.productId = productsData.productId
      }

      //loop over monthly plans
      const monthlyPrices = productsData.billingCycleMonthly
      monthlyPrices.forEach((monthlyPrice) => {
        if (monthlyPrice.currency.data.attributes.code === currencySelected) {
          temporaryPlanObject.billingCycle.monthly.amount = monthlyPrice.amount
          temporaryPlanObject.billingCycle.monthly.priceId = monthlyPrice.priceId
          temporaryPlanObject.billingCycle.monthly.multiPriceIds = monthlyPrice.multiPriceIds
        }
      })

      //loop over yearly plans
      const yearlyPlans = productsData.billingCycleYearly
      yearlyPlans.forEach((yearlyPrice) => {
        if (yearlyPrice.currency.data.attributes.code === currencySelected) {
          temporaryPlanObject.billingCycle.yearly.amount = yearlyPrice.amount
          temporaryPlanObject.billingCycle.yearly.priceId = yearlyPrice.priceId
          temporaryPlanObject.billingCycle.yearly.multiPriceIds = yearlyPrice.multiPriceIds
        }
      })
      tempStripePlansHolder.push(temporaryPlanObject)
    })
    commit('SET_STRIPE_PLANS', tempStripePlansHolder)
  },
}
